import { type UserAndPopulationStatsForOneJournal } from "../../../../common/types/index.js";
import styles from "../../pages/UserDashboard/UserDashboard.module.css";
import ComparisonTable from "./ComparisonTable.js";

interface StatsPageProps {
  readonly userStats: UserAndPopulationStatsForOneJournal[];
  readonly result: {
    totalDays: number;
    totalPapers: number;
    averageRandR: number;
  };
}

const StatsPage = ({ userStats, result }: StatsPageProps) => (
  <main className={styles["stats-page"]}>
    <h1>My Stats</h1>
    {userStats.length > 0 ? (
      <ComparisonTable userStats={userStats} result={result} />
    ) : (
      <p>You have yet to submit journal data. Scan a journal to get started!</p>
    )}
  </main>
);

export default StatsPage;
